import { Navigate } from 'react-router';

import { ANY_SPORT_PLAY } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

const GamePage = () => {
  const { generateSportContextPath } = useSportContext();
  return <Navigate to={generateSportContextPath(ANY_SPORT_PLAY)} replace />;
};

export default GamePage;
